import React from "react";
import NavBar from "./header/NavBar";
import AboutMe from "./aboutme/AboutMe";
import MoreAboutMe from "./moreaboutme/MoreAboutMe";
import MySkill from "./myskills/MySkill";
import MyExperience from "./experience/MyExperience";
import Project from "./projects/Project";
import Footer from "./footer/Footer";

const Start = () => {
  return (
    <>
      <NavBar />
      <AboutMe />
      <MoreAboutMe />
      <MySkill />
      <MyExperience />
      <Project />
      <Footer />
    </>
  );
};

export default Start;
